/*@flow*/
import ChartNumina from '../ChartNumina';
import ChartCarmera from '../ChartCarmera';
import Chart311 from '../Chart311';
// import ChartBuildingPermits from '../ChartBuildingPermits';
import ChartBiz from '../ChartBiz';
import ChartVacancy from '../ChartVacancy';
import ChartListing from '../ChartListing';
import ChartListingAndVacancy from '../ChartListingAndVacancy';
import ChartAssetInventory from '../ChartAssetInventory';
import React from 'react';
import Section from '../Section';

export default [
  {
    type: 'section',
    name: 'Mobility & Pedestrians',
    component: React.createFactory<typeof Section>(Section),
    charts: [
      {
        type: 'chart',
        name: 'Pedestrian Activity Scores by Street',
        source: 'CARMERA Street Scores',
        component: React.createFactory<typeof ChartCarmera>(ChartCarmera),
      },
      {
        type: 'chart',
        name: 'Mobility Analysis at Sensor Locations',
        source: 'Numina Street Sensors',
        component: React.createFactory<typeof ChartNumina>(ChartNumina),
      },
    ],
  },
  {
    type: 'section',
    name: 'Quality of Life',
    component: React.createFactory<typeof Section>(Section),
    charts: [
      {
        type: 'chart',
        name: '311 Complaints',
        source: 'NYC Open Data Portal',
        component: React.createFactory<typeof Chart311>(Chart311),
      },
    ],
  },
  {
    type: 'section',
    name: 'Street Conditions',
    component: React.createFactory<typeof Section>(Section),
    charts: [
      {
        type: 'chart',
        name: 'Streetscape Assets Inventory',
        source: 'Downtown Brooklyn Partnership',
        component: React.createFactory<typeof ChartAssetInventory>(
          ChartAssetInventory
        ),
      },
      // {
      //   type: 'chart',
      //   name: 'Streetscape Assets In Need of Attention',
      //   source: 'Citiesense',
      //   component: React.createFactory<*>(() => null),
      // },
    ],
  },
  {
    type: 'section',
    name: 'Commercial Space',
    component: React.createFactory<typeof Section>(Section),
    charts: [
      {
        type: 'chart',
        name: 'Available and Vacant Space On Market',
        source: 'Citiesense',
        component: React.createFactory<typeof ChartListingAndVacancy>(
          ChartListingAndVacancy
        ),
        visible: process.env.__DEV__,
      },
      {
        type: 'chart',
        name: 'Businesses & Attractions',
        source: 'Citiesense',
        component: React.createFactory<typeof ChartBiz>(ChartBiz),
      },
      {
        type: 'chart',
        name: 'Vacancy',
        source: 'Citiesense',
        component: React.createFactory<typeof ChartVacancy>(ChartVacancy),
      },
      {
        type: 'chart',
        name: 'Available Space Listed On Market',
        source: 'Downtown Brooklyn Partnership',
        component: React.createFactory<typeof ChartListing>(ChartListing),
      },
      // {
      //   type: 'chart',
      //   name: 'Deed Transfers & Mortgages',
      //   source: 'NYC Open Data Portal',
      //   component: React.createFactory<*>(() => null),
      //   visible: process.env.__DEV__,
      // },
    ],
  },
  // {
  //   type: 'section',
  //   name: 'Development Activity',
  //   component: React.createFactory<typeof Section>(Section),
  //   charts: [
  //     // {
  //     //   type: 'chart',
  //     //   name: 'Building Permit Applications',
  //     //   source: 'NYC Open Data Portal',
  //     //   component: React.createFactory<typeof ChartBuildingPermits>(
  //     //     ChartBuildingPermits
  //     //   ),
  //     // },
  //     // {
  //     //   type: 'chart',
  //     //   name: 'ECB Violations',
  //     //   source: 'NYC Open Data Portal',
  //     //   component: React.createFactory<*>(() => null),
  //     //   visible: process.env.__DEV__,
  //     // },
  //   ],
  // },
];
